import { render } from "./PaymentStatus.vue?vue&type=template&id=666fc08e&scoped=true"
import script from "./PaymentStatus.vue?vue&type=script&lang=js"
export * from "./PaymentStatus.vue?vue&type=script&lang=js"

import "./PaymentStatus.vue?vue&type=style&index=0&id=666fc08e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666fc08e"]])

export default __exports__